<button
  class="bottom-action-bar"
  [style.background-color]="backgroundColor()"
  [style.color]="textColor()"
  (click)="actionClick.emit()"
>
  <div class="bar-content">
    <span class="bar-title">{{ title() }}</span>
    @if (subtitle()) {
      <span class="bar-subtitle">{{ subtitle() }}</span>
    }
  </div>

  <div class="bar-action">
    <umss-icon [name]="iconName()" />
  </div>
</button>
